import {
    Grid,
    Theme,
    Container,
    makeStyles,
    CssBaseline,
    createStyles,
    Button,
    Snackbar
} from '@material-ui/core'
import React,
{
    useState,
    useEffect, useContext,
} from 'react';
import Firebase from 'firebase/app';
import "firebase/analytics";
import 'firebase/auth';
import Tour from 'reactour';
import 'firebase/firestore';
import Network from './google-auth';
import WelcomeSection from "./Welcome";
import {Footer} from './Navigation/Footer';
import { Header } from './Navigation/Header';
import { useAuthState } from 'react-firebase-hooks/auth';
import { SearchPageController } from './Features/Search/SearchPageController';
import {BuildingProvider} from './Common/Context/Providers/BuildingContext';
import { CalendarProvider } from './Common/Context/Providers/CalendarContext';
import { FavoritesProvider } from './Common/Context/Providers/FavoritesContext';
import DashboardPageController from './Features/Dashboard/Controllers/DashboardPageController';
import {CoursesProvider} from './Common/Context/Providers/CourseContext';
import {SearchProvider} from './Common/Context/Providers/SearchContext';
import {useDocumentData} from "react-firebase-hooks/firestore";
import MuiAlert from '@material-ui/lab/Alert';
import {PlannerViewController} from "./Features/Planner/Controllers/PlannerViewController";
import {FeedMaterial} from "./Feed/FeedMaterial";
import {SnackBarContext} from './Common/Context/SnackBarContext'
import CalendarViewController from "./Features/Calendar/Controllers/CalendarViewController";

// needed for retrieving qeury params from URL (android refreshed notification token)
const queryString = require('query-string');


//firebase auth initiating (this needed)
const firebaseConfig = {
    apiKey: "AIzaSyDguZojAF_DEZVR9c9KmoBoVRCoFBnNwGw",
    authDomain: "student-app-1329.firebaseapp.com",
    databaseURL: "https://student-app-1329.firebaseio.com",
    projectId: "student-app-1329",
    storageBucket: "student-app-1329.appspot.com",
    messagingSenderId: "683737181144",
    appId: "1:683737181144:web:5dda86276d8c67bebba0ad",
    measurementId: "G-FRNY3SBSRX"
};

// initiation is occuring first so that is fine
Firebase.initializeApp(firebaseConfig);

// Cache :: firebase offline
Firebase.firestore().settings({
    cacheSizeBytes: Firebase.firestore.CACHE_SIZE_UNLIMITED
});

Firebase.firestore().enablePersistence();

// initialize analytics for the web.
let analytics  = Firebase.analytics();

analytics.logEvent('Dashboard',
    {
    page_location:  'Dashboard',
    page_title: 'Dashboard'
});

export default function App(props: any) {

    // Variables
    let network = new Network();
    let db = Firebase.firestore();

    const classes = useStyles();
    const [token, setToken] = useState<string>();
    const [open, setOpen] = useState(false);
    const [page, setPage] = useState('dashboard');
    const [tourTaken, setTourTaken] = useState(true);
    const [user, authLoading, authError] = useAuthState(Firebase.auth());
    const [userData, userLoading, userError] = useDocumentData( db.collection('users').doc(user ? user.uid : " "));
    const [upNext, setUpNext] = useState(false);
    const snackbarContext = useContext(SnackBarContext);

    // Tutorial states
    const [isTourOpen, updateTourStatus]= useState(false);
    const accentColor = "#026a38";


    const login = () => {
        //@ts-ignore
            if (window.webkit) {

                //@ts-ignore
                window.webkit.messageHandlers.login.postMessage({body: true});
            } else {
            network.googleAuth().then((user: any) => {
                if (user && user.token)
                    setToken(user.token)
            } );
        }
    };

    const pages: any = {
        'dashboard':
            <DashboardPageController
            login={login}
            token={token}
            userData={userData}
            setPage={(data: any) => {
                const { page, upNext} = data;
                if (page) {
                    setPage(page);
                    if (upNext) {
                        setUpNext(upNext)
                    }
                }
            }}
            refresh={(refreshTypes: string[]) => updateData(user, refreshTypes).then((resp: any) => {

                snackbarContext.setSnackBarInfo({
                    status: true,
                    type: resp == undefined ? 'success' : 'error',
                    message: resp == undefined ? 'Success' : resp.error
                })

            })}
            />,
        'calendar': <CalendarViewController />,
                // <CalendarPageController/>,
        'planner': <PlannerViewController
            upNext={upNext}
            resetUpNext={() => setUpNext(undefined)}
            refresh={(refreshTypes: string[]) => updateData(user, refreshTypes).then((resp: any) => {

                snackbarContext.setSnackBarInfo({
                    status: true,
                    type: resp == undefined ? 'success' : 'error',
                    message: resp == undefined ? 'Success' : resp.error
                })

            })}

        />,
        'feed': <FeedMaterial/>
    };

    // Functions
    // @ts-ignore
    setID = (authToken: string) => setToken(authToken);

    // iOS Push Token update
    //@ts-ignore
   updatePushToken = (pushtoken: string) => {

        let pToken: string | null = pushtoken == 'error' ? null : pushtoken;
       updateFirebaseTokens(user, TokenType.PushNotification, pToken)
   };

   const importInitialData = (user: any) => {
       if (user) {
           let userRef = db.collection('users').doc(user.uid);
           let initialData = {
               email: user.email,
               uid: user.uid,
               tutorial: false,
               notificationToken: null,
               googleAuthToken: null
           };
           userRef.set(initialData, {merge: true}).then(() => {
               updateData(user, ['JasperCard', 'Courses']).then((resp: any) => {

                       if (!resp) {
                           updateTourStatus(true)
                       }

               });

           });
       }
   };



   const updateData = async (user: any, refreshTypes: string[]) => {
       if (user) {
            if (window.webkit && window.webkit.messageHandlers.feedback) {
                window.webkit.messageHandlers.feedbackPrepare.postMessage({body: true})
            }
           let myHeaders = new Headers();
           myHeaders.append("Content-Type", "application/json");
           let firebase_token = await Firebase.auth().currentUser.getIdToken();
           let raw = JSON.stringify({"uid":user.uid ,"itemsToRefresh": refreshTypes});
           let requestOptions = {
               method: 'POST',
               headers: {
               'Content-Type': 'application/json',
               'Authorization':  `Bearer ${firebase_token}`
                },
               body: raw,
           };
           try {
               let resp = await fetch('https://jaspercardws2.manhattan.edu:7443/api/refreshWithToken', requestOptions);
               let respData = await resp.json();
               return new Promise((resolve: any, reject: any) => {

                    if (window.webkit) {
                       if (resp.ok) {
                           let state = true;
                           let data = Object.values(respData)
                           for (const index in  data){
                               if (data[index].error) {
                                   state = false
                               }
                           }
                            if (window.webkit.messageHandlers.feedback) {
                                window.webkit.messageHandlers.feedback.postMessage({type: state ? 'Success' : 'Error'});
                            }
                           state ? resolve() : reject({error: 'Failed. Please try again!'})
                       } else {
                               reject({error: respData.error})
                        }
                    } else {
                        resolve()
                    }
                })
           } catch(error) {
               return new Promise((resolve: any, reject: any) => {
                  reject({error})
               })
           }
       }
   };

   enum TokenType {
       PushNotification = "notificationToken",
       GoogleAuth = "googleAuthToken",
   }

   const updateFirebaseTokens = (user: any, tokenType: TokenType, token: string | null) => {
       if (user) {
           // @ts-ignore
           let userRef = Firebase.firestore().collection('users').doc(user.uid);
           userRef.update({
              [tokenType]: token,
           });
       }
   };

   // Side Effects

    // Import initial data on login
    useEffect(() => {
        updateData(user, ['JasperCard', 'Courses']);

        if (!user && page == 'planner') {
            setPage('dashboard')
        }

    }, [user]);

    // updateData(user, ['JasperCard', 'Courses']);


    useEffect( () => {

        if (user && userData) {
            // updateData(user);
            const parsed = queryString.parse(window.location.search);
            if (parsed.notificationToken !== undefined && parsed.notificationToken !== 'empty'){
                updateFirebaseTokens(user, TokenType.PushNotification, parsed.notificationToken)
            }

            if (token) {
                updateFirebaseTokens(user, TokenType.GoogleAuth, token);
            }

            // @ts-ignore
            if (window.webkit) {
                // @ts-ignore
                window.webkit.messageHandlers.auth.postMessage({body: true});
                //@ts-ignore
                window.webkit.messageHandlers.pushToken.postMessage({body: true});

            }
        }
    });

    useEffect(() => {
        // this is working now, debugging analytics events
        //TODO :: FIGURE OUT WHAT NEEDS TO BE LOGGED
        // @ts-ignore

        // @ts-ignore
        if (token && window.webkit)
            network.googleAuth(token)

    }, [token]);


    useEffect(() => {


        if (userLoading === false) {
            // console.log(userLoading)
            if (user) {
                if (userData) {
                    if (userData.tutorial === false)
                        updateTourStatus(true);

                } else {
                    importInitialData(user);
                }
            }
        }

    }, [userLoading]);


   /* const updateWelcome = () => {

    }
     */
    const tourConfig = [
        {
            selector: '[data-tutorial="tut-1"]',
            content: `Ok, lets start with the name. Welcome to Glance MC 2.0. `,

        },
        {
            selector: '[data-tutorial="tut-2"]',
            content: `Say hello to your portable JasperCard. It displays your information for quick reference moments.` +
                ` You may also pay using Jasper Dollars by scanning the barcode at School dining locations.`,

        },
        {
            selector: '[data-tutorial="tut-3"]',
            content: `You currently are in the Dashboard, here you will find your Planner which contains your courses. ` +
                `Your Favorites & Featured links can also be found here.`,

        },
        {
            selector: '[data-tutorial="tut-4"]',
            content: `This will open up our Smart Search. As you type, it will return the college's Quicklinks` +
                ` and Employee Directory. Feel free to "Favorite" what you'd like for quick and easy access from the Dashboard.`,


        },
        {
            selector: '[data-tutorial="tut-6"]',
            content: () => (
              <>
                  <div>To get to the Calendar Press here. From there you can view events from Today, Week, All.
                  You can also favorite events for easy viewing in your Dashboard.</div>
                  <Button
                      variant={'outlined'}
                      className={classes.completeButton}
                      onClick={() => {
                      if (user) {
                          updateTourStatus(false);

                          // @ts-ignore
                          db.collection('users').doc(user.uid).update({tutorial: true})
                      }
                  }}>Complete</Button>
              </>)
        }

    ];

    // @ts-ignore
    return (
        <>
            <Tour
                onRequestClose={() => updateTourStatus(false)}
                steps={tourConfig}
                isOpen={isTourOpen}
                rounded={20}
                accentColor={accentColor}
                disableInteraction={true}
                closeWithMask={false}
                startAt={0}
                showCloseButton={false}
            />

            <CssBaseline/>
            <Container
                data-tutorial={'observable-parent'}
                maxWidth={'sm'}
                disableGutters={true}
                className={classes.root}
            >
                <CalendarProvider>
                <BuildingProvider>
                    <CoursesProvider>
                        <SearchProvider>
                            {!tourTaken &&
                               <WelcomeSection/>
                            }
                            {tourTaken &&
                                <>
                            <Header />
                            <Grid
                                className={classes.content}
                                container
                                >
                                <Grid
                                item
                                className={classes.fill}
                                xs={12}
                                >
                                    <FavoritesProvider>
                                        {pages[page]}
                                         <SearchPageController
                                                          data-tutorial={'tut-5'}
                                                            open={open}
                                                            dismiss={() => setOpen(false)}
                                                        />

                                    </FavoritesProvider>
                                </Grid>
                                <Snackbar
                                    autoHideDuration={2000}
                                    open={snackbarContext.status}
                                    onClose={
                                        (event: any, reason: string) => {
                                            snackbarContext.setSnackBarInfo({status: false})
                                        }
                                    }
                                >
                                    <MuiAlert
                                        color={snackbarContext.type}
                                        severity={snackbarContext.type}
                                        variant={'filled'}
                                    > {snackbarContext.message}</MuiAlert>
                                </Snackbar>
                            </Grid>
                                <Footer
                                    page={page}
                                    setOpen={() => setOpen(true)}
                                    onSelect={(value: string) => {
                                        setPage(value);
                                    }
                                }
                                />
                             </>
                             }
                        </SearchProvider>
                    </CoursesProvider>
                </BuildingProvider>
                </CalendarProvider>
            </Container>
        </>
    );
};

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            height: '100vh',
            backgroundColor: 'white'
        },
        content: {
            position: 'relative',
            overflowX: 'hidden',
            overflowY: 'scroll',
            height: 'calc(100% - 120px)',
        },
        fill: {
            flex: 1
        },
        completeButton: {
            marginTop: 16,
            borderColor: '#046A38',
            borderWidth: 2,
            color: '#046A38',

        },
    })
);

